
document.addEventListener('DOMContentLoaded', () => {
  const biographySwiper = Array.from(
    document.querySelectorAll('.biography__swiper')
  );

  biographySwiper.forEach(
    (swiperContainer) =>
      new Swiper(swiperContainer, {
        // Optional parameter
        direction: 'horizontal',
        slidesPerView: 1,

        // autoplay: {
        //   delay: 0,
        // },
        // speed: slideSpeed,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next.biography-button-next',
          prevEl: '.swiper-button-prev.biography-button-prev',
        },
      })
  );
});